const TunMap = {
    Gouv:[
        {id:"1", text:"Tunis", value:"Tunis"},
        {id:"2", text:"Sfax",value:"Sfax"},
        {id:"3", text:"Nabeul", value:"Nabeul"},
        {id:"4", text:"Sousse", value:"Sousse"},
        {id:"5", text:"Ben Arous",value:"Ben Arous"},
        {id:"6", text:"Ariana",value:"Ariana"},
        {id:"7", text:"Kairouan",value:"Kairouan"},
        {id:"8", text:"Bizerte",value:"Bizerte"},
        {id:"9", text:"Monastir",value:"Monastir"},
        {id:"10", text:"Medenine",value:"Medenine"},
        {id:"11", text:"Kasserine",value:"Kasserine"},
        {id:"12", text:"Sidi Bouzid",value:"Sidi Bouzid"},
        {id:"13", text:"Mahdia",value:"Mahdia"},
        {id:"14", text:"Jendouba",value:"Jendouba"},
        {id:"15", text:"Manouba",value:"Manouba"},
        {id:"16", text:"Gabes",value:"Gabes"},
        {id:"17", text:"Gafsa",value:"Gafsa"},
        {id:"18", text:"Beja",value:"Beja"},
        {id:"19", text:"Kef",value:"Kef"},
        {id:"20", text:"Siliana",value:"Siliana"},
        {id:"21", text:"Zaghouan",value:"Zaghouan"},
        {id:"22", text:"Kebili",value:"Kebili"},
        {id:"23", text:"Tataouine",value:"Tataouine"},
        {id:"24", text:"Tozeur",value:"Tozeur"},
    ],
    Deleg:[
        {id:"1",tag:"Tunis",text:"Carthage",value:"Carthage"},
        {id:"2",tag:"Tunis",text:"Al Madinah",value:"Al Madinah"},
        {id:"3",tag:"Tunis",text:"Bab El Bhar",value:"Bab El Bhar"},
        {id:"4",tag:"Tunis",text:"Bab Souika",value:"Bab Souika"},
        {id:"5",tag:"Tunis",text:"El Omrane",value:"El Omrane"},
        {id:"6",tag:"Tunis",text:"El Omrane Superieur",value:"El Omrane Superieur"},
        {id:"7",tag:"Tunis",text:"Ettahrir",value:"Ettahrir"},
        {id:"8",tag:"Tunis",text:"El Menzah",value:"El Menzah"},
        {id:"9",tag:"Tunis",text:"Cité El Khadra",value:"Cité El Khadra"},
        {id:"10",tag:"Tunis",text:"Le Bardo",value:"Le Bardo"},
        {id:"11",tag:"Tunis",text:"Séjoumi",value:"Séjoumi"},
        {id:"12",tag:"Tunis",text:"Ezzouhour",value:"Ezzouhour"},
        {id:"13",tag:"Tunis",text:"El Hrayria",value:"El Hrayria"},
        {id:"14",tag:"Tunis",text:"Sidi Hassine",value:"Sidi Hassine"},
        {id:"15",tag:"Tunis",text:"El Ouardia",value:"El Ouardia"},
        {id:"16",tag:"Tunis",text:"El Kabaria",value:"El Kabaria"},
        {id:"17",tag:"Tunis",text:"Sidi El Béchir",value:"Sidi El Béchir"},
        {id:"18",tag:"Tunis",text:"Djebel Jelloud",value:"Djebel Jelloud"},
        {id:"19",tag:"Tunis",text:"La Goulette",value:"La Goulette"},
        {id:"20",tag:"Tunis",text:"Le Kram",value:"Le Kram"},
        {id:"21",tag:"Tunis",text:"Le Marsa",value:"Le Marsa"},
        {id:"22",tag:"Ariana",text:"Ariana Ville",value:"Ariana Ville"},
        {id:"23",tag:"Ariana",text:"La Soukra",value:"La Soukra"},
        {id:"24",tag:"Ariana",text:"Raoued",value:"Raoued"},
        {id:"25",tag:"Ariana",text:"Kalâat el-Andalous",value:"Kalâat el-Andalous"},
        {id:"26",tag:"Ariana",text:"Sidi Thabet",value:"Sidi Thabet"},
        {id:"27",tag:"Ariana",text:"City Ettadhamon",value:"City Ettadhamon"},
        {id:"28",tag:"Ariana",text:"Mnihla",value:"Mnihla"},
        {id:"29",tag:"Manouba",text:"La Manouba",value:"La Manouba"},
        {id:"30",tag:"Manouba",text:"Wad Ellil",value:"Wad Ellil"},
        {id:"31",tag:"Manouba",text:"Tebourba",value:"Tebourba"},
        {id:"32",tag:"Manouba",text:"El Battan",value:"El Battan"},
        {id:"33",tag:"Manouba",text:"Djedeida",value:"Djedeida"},
        {id:"34",tag:"Manouba",text:"El Mornagia",value:"El Mornagia"},
        {id:"35",tag:"Manouba",text:"Borj El Amri",value:"Borj El Amri"},
        {id:"36",tag:"Manouba",text:"Douar Hicher",value:"Douar Hicher"},
        {id:"37",tag:"Ben Arous",text:"Ben Arous",value:"Ben Arous"},
        {id:"38",tag:"Ben Arous",text:"Medina Jedida",value:"Medina Jedida"},
        {id:"39",tag:"Ben Arous",text:"El Mourouj",value:"El Mourouj"},
        {id:"40",tag:"ben arous",text:"Hammam Lif",value:"Hammam Lif"},
        {id:"41",tag:"Ben Arous",text:"Hammam Chott",value:"Hammam Chott"},
        {id:"42",tag:"Ben Arous",text:"Bou Mhel el-Bassatine",value:"Bou Mhel el-Bassatine"},
        {id:"43",tag:"Ben Arous",text:"Ezzahra",value:"Ezzahra"},
        {id:"44",tag:"Ben Arous",text:"Radès",value:"Radès"},
        {id:"45",tag:"Ben Arous",text:"Mégrine",value:"Mégrine"},
        {id:"46",tag:"Ben Arous",text:"Mohamedia",value:"Mohamedia"},
        {id:"47",tag:"Ben Arous",text:"Fouchana",value:"Fouchana"},
        {id:"48",tag:"Ben Arous",text:"Mornag",value:"Mornag"},
        {id:"49",tag:"Nabeul",text:"Nabeul",value:"Nabeul"},
        {id:"50",tag:"nabeul",text:"",value:""},
        {id:"51",tag:"nabeul",text:"",value:""},
        {id:"52",tag:"Nabeul",text:"Korba",value:"Korba"},
        {id:"53",tag:"Nabeul",text:"Menzel Temime",value:"Menzel Temime"},
        {id:"54",tag:"Nabeul",text:"El Mida",value:"El Mida"},
        {id:"55",tag:"Nabeul",text:"Kélibia",value:"Kélibia"},
        {id:"56",tag:"Nabeul",text:"Hammam Ghezèze",value:"Hammam Ghezèze"},
        {id:"57",tag:"Nabeul",text:"El Haouaria",value:"El Haouaria"},
        {id:"58",tag:"nabeul",text:"Takelsa",value:"Takelsa"},
        {id:"59",tag:"nabeul",text:"Soliman",value:"Soliman"},
        {id:"60",tag:"nabeul",text:"Manzel Bou Zalfa ",value:"Manzel Bou Zalfa "},
        {id:"61",tag:"nabeul",text:"Bni Khalled",value:"Bni Khalled"},
        {id:"62",tag:"nabeul",text:"Grombalia",value:"Grombalia"},
        {id:"63",tag:"nabeul",text:"Bouargoub",value:"Bouargoub"},
        {id:"64",tag:"nabeul",text:"Hammamet",value:"Hammamet"},
        {id:"65",tag:"Bizerte",text:"Bizerte Nord",value:"Bizerte Nord"},
        {id:"66",tag:"Bizerte",text:"Zarzouna",value:"Zarzouna"},
        {id:"67",tag:"Bizerte",text:"Bizerte Sud",value:"Bizerte Sud"},
        {id:"68",tag:"Bizerte",text:"Sejnane",value:"Sejnane"},
        {id:"69",tag:"Bizerte",text:"Joumin",value:"Joumin"},
        {id:"70",tag:"Bizerte",text:"Mateur",value:"Mateur"},
        {id:"71",tag:"Bizerte",text:"Ghazella",value:"Ghazella"},
        {id:"72",tag:"Bizerte",text:"Menzel Bourguiba",value:"Menzel Bourguiba"},
        {id:"73",tag:"Bizerte",text:"Tinja",value:"Tinja"},
        {id:"74",tag:"Bizerte",text:"Outik",value:"Outik"},
        {id:"75",tag:"Bizerte",text:"Ghar El Melh",value:"Ghar El Melh"},
        {id:"76",tag:"Bizerte",text:"Menzel Jemil",value:"Menzel Jemil"},
        {id:"77",tag:"Bizerte",text:"El Alia",value:"El Alia"},
        {id:"78",tag:"Bizerte",text:"Ras Djebel",value:"Ras Djebel"},
        {id:"79",tag:"Zaghouan",text:"Zaghouan",value:"Zaghouan"},
        {id:"80",tag:"Zaghouan",text:"Ezzriba",value:"Ezzriba"},
        {id:"81",tag:"Zaghouan",text:"Bir Mcharga",value:"Bir Mcharga"},
        {id:"82",tag:"Zaghouan",text:"El Fahs",value:"El Fahs"},
        {id:"83",tag:"Zaghouan",text:"Nadhour",value:"Nadhour"},
        {id:"84",tag:"Zaghouan",text:"Souaf",value:"Souaf"},
        {id:"85",tag:"Sousse",text:"Sousse Médina",value:"Sousse Médina"},
        {id:"86",tag:"sousse",text:"Ksiba Thrayet",value:"Ksiba Thrayet"},
        {id:"87",tag:"Sousse",text:"Sousse Riadh",value:"Sousse Riadh"},
        {id:"88",tag:"sousse",text:"Sousse Jouahara",value:"Sousse Jouahara"},
        {id:"89",tag:"sousse",text:"Sousse Sidi Abdelhamid",value:"Sousse Sidi Abdelhamid"},
        {id:"90",tag:"Sousse",text:"Hammam Sousse",value:"Hammam Sousse"},
        {id:"91",tag:"Sousse",text:"Akouda",value:"Akouda"},
        {id:"92",tag:"sousse",text:"Kalaa Kobra",value:"Kalaa Kobra"},
        {id:"93",tag:"sousse",text:"Sidi Bou Ali",value:"Sidi Bou Ali"},
        {id:"94",tag:"Sousse",text:"Hergla",value:"Hergla"},
        {id:"95",tag:"Sousse",text:"Enfida",value:"Enfida"},
        {id:"96",tag:"Sousse",text:"Bouficha",value:"Bouficha"},
        {id:"97",tag:"sousse",text:"Kondar",value:"Kondar"},
        {id:"98",tag:"Sousse",text:"Sidi El Hani",value:"Sidi El Hani"},
        {id:"99",tag:"Sousse",text:"M'saken",value:"M'saken"},
        {id:"100",tag:"sousse",text:"Kalaa Soghra",value:"Kalaa Soghra"},
        {id:"101",tag:"Monastir",text:"Monastir",value:"Monastir"},
        {id:"102",tag:"Monastir",text:"Werdanin",value:"Werdanin"},
        {id:"103",tag:"Monastir",text:"Sahlin",value:"Sahlin"},
        {id:"104",tag:"Monastir",text:"Zermdin",value:"Zermdin"},
        {id:"105",tag:"Monastir",text:"Bni Hassan",value:"Bni Hassan"},
        {id:"106",tag:"Monastir",text:"Jammel",value:"Jammel"},
        {id:"107",tag:"Monastir",text:"Benbla",value:"Benbla"},
        {id:"108",tag:"Monastir",text:"El Moknin",value:"El Moknin"},
        {id:"109",tag:"Monastir",text:"El Bgalta",value:"El Bgalta"},
        {id:"110",tag:"Monastir",text:"Tbolba",value:"Tbolba"},
        {id:"111",tag:"Monastir",text:"Ksar Hlel",value:"Ksar Hlel"},
        {id:"112",tag:"Monastir",text:"Ksibet Mediouni",value:"Ksibet Mediouni"},
        {id:"113",tag:"Monastir",text:"Sayada Bouhjar",value:"Sayada Bouhjar"},
        {id:"114",tag:"Mahdia",text:"Mahdia",value:"Mahdia"},
        {id:"115",tag:"Mahdia",text:"Boumerdass",value:"Boumerdass"},
        {id:"116",tag:"Mahdia",text:"Ouled Chamekh",value:"Ouled Chamekh"},
        {id:"117",tag:"Mahdia",text:"Chorbane",value:"Chorbane"},
        {id:"118",tag:"Mahdia",text:"Hebira",value:"Hebira"},
        {id:"119",tag:"Mahdia",text:"Essouassi",value:"Essouassi"},
        {id:"120",tag:"Mahdia",text:"El Jem",value:"El Jem"},
        {id:"121",tag:"Mahdia",text:"Chebba",value:"Chebba"},
        {id:"122",tag:"Mahdia",text:"Melloulèche",value:"Melloulèche"},
        {id:"123",tag:"Mahdia",text:"Sidi Alouane",value:"Sidi Alouane"},
        {id:"124",tag:"Mahdia",text:"Ksour Essef",value:"Ksour Essef"},
        {id:"125",tag:"sfax",text:"Sfax Medina",value:"Sfax Medina"},
        {id:"126",tag:"Sfax",text:"Sfax Ouest",value:"Sfax Ouest"},
        {id:"127",tag:"Sfax",text:"Sakiet Ezzit",value:"Sakiet Ezzit"},
        {id:"128",tag:"sfax",text:"Sakiet Dayer",value:"Sakiet Dayer"},
        {id:"129",tag:"Sfax",text:"Sfax Sud",value:"Sfax Sud"},
        {id:"130",tag:"Sfax",text:"Thyna",value:"Thyna"},
        {id:"131",tag:"sfax",text:"Aagareb",value:"Aagareb"},
        {id:"132",tag:"Sfax",text:"Jebiniana",value:"Jebiniana"},
        {id:"133",tag:"Sfax",text:"El Amra",value:"El Amra"},
        {id:"134",tag:"Sfax",text:"El Hencha",value:"El Hencha"},
        {id:"135",tag:"Sfax",text:"Menzel Chaker",value:"Menzel Chaker"},
        {id:"136",tag:"Sfax",text:"Graïba",value:"Graïba"},
        {id:"137",tag:"sfax",text:"Bir Ali Ben Khalifa",value:"Bir Ali Ben Khalifa"},
        {id:"138",tag:"Sfax",text:"Skhira",value:"Skhira"},
        {id:"139",tag:"Sfax",text:"Mahrès",value:"Mahrès"},
        {id:"140",tag:"sfax",text:"Kerkna",value:"Kerkna"},
        {id:"141",tag:"Beja",text:"Béja Nord",value:"Béja Nord"},
        {id:"142",tag:"Beja",text:"Béja Sud",value:"Béja Sud"},
        {id:"143",tag:"Beja",text:"Amdoun",value:"Amdoun"},
        {id:"144",tag:"Beja",text:"Nefza",value:"Nefza"},
        {id:"145",tag:"Beja",text:"Téboursouk",value:"Téboursouk"},
        {id:"146",tag:"Beja",text:"Thibar",value:"Thibar"},
        {id:"147",tag:"Beja",text:"Testour",value:"Testour"},
        {id:"148",tag:"Beja",text:"Goubellat",value:"Goubellat"},
        {id:"149",tag:"Beja",text:"Medjez el-Bab",value:"Medjez el-Bab"},
        {id:"150",tag:"Jendouba",text:"Jendouba",value:"Jendouba"},
        {id:"151",tag:"Jendouba",text:"Jendouba Nord",value:"Jendouba Nord"},
        {id:"152",tag:"Jendouba",text:"Bousalem",value:"Bousalem"},
        {id:"153",tag:"Jendouba",text:"Taberka",value:"Taberka"},
        {id:"154",tag:"Jendouba",text:"Ain Drahem",value:"Ain Drahem"},
        {id:"155",tag:"Jendouba",text:"Fernana",value:"Fernana"},
        {id:"156",tag:"Jendouba",text:"Ghar Dimaou",value:"Ghar Dimaou"},
        {id:"157",tag:"Jendouba",text:"Wad Mliz",value:"Wad Mliz"},
        {id:"158",tag:"Jendouba",text:"Bolta Bouaouan",value:"Bolta Bouaouan"},
        {id:"159",tag:"Kef",text:"Kef Est",value:"Kef Est"},
        {id:"160",tag:"Kef",text:"Kef Sud",value:"Kef Sud"},
        {id:"161",tag:"Kef",text:"Nebber",value:"Nebber"},
        {id:"162",tag:"Kef",text:"Sakiet Sidi-Youssef",value:"Sakiet Sidi-Youssef"},
        {id:"163",tag:"Kef",text:"Tajerouine",value:"Tajerouine"},
        {id:"164",tag:"Kef",text:"Kalaaet Sinen",value:"Kalaaet Sinen"},
        {id:"165",tag:"Kef",text:"Kalaa Khesba",value:"Kalaa Khesba"},
        {id:"166",tag:"Kef",text:"Jerissa ",value:"Jerissa "},
        {id:"167",tag:"Kef",text:"Ksour",value:"Ksour"},
        {id:"168",tag:"Kef",text:"Dahmani",value:"Dahmani"},
        {id:"169",tag:"Kef",text:"Sers",value:"Sers"},
        {id:"170",tag:"Siliana",text:"Siliana Nord",value:"Siliana Nord"},
        {id:"171",tag:"Siliana",text:"Siliana Sud",value:"Siliana Sud"},
        {id:"172",tag:"Siliana",text:"Bou Arada",value:"Bou Arada"},
        {id:"173",tag:"Siliana",text:"Gaâfour",value:"Gaâfour"},
        {id:"174",tag:"Siliana",text:"El Aroussa",value:"El Aroussa"},
        {id:"175",tag:"Siliana",text:"El Krib",value:"El Krib"},
        {id:"176",tag:"Siliana",text:"Sidi Bourouis",value:"Sidi Bourouis"},
        {id:"177",tag:"Siliana",text:"Makthar",value:"Makthar"},
        {id:"178",tag:"Siliana",text:"Rouhia",value:"Rouhia"},
        {id:"179",tag:"Siliana",text:"Kesra",value:"Kesra"},
        {id:"180",tag:"Siliana",text:"Bargou",value:"Bargou"},
        {id:"181",tag:"Kairouan",text:"Kairouan Nord",value:"Kairouan Nord"},
        {id:"182",tag:"Kairouan",text:"Kairouan Sud",value:"Kairouan Sud"},
        {id:"183",tag:"Kairouan",text:"Chbika",value:"Chbika"},
        {id:"184",tag:"Kairouan",text:"Sbikha",value:"Sbikha"},
        {id:"185",tag:"Kairouan",text:"El Weslatya",value:"El Weslatya"},
        {id:"186",tag:"Kairouan",text:"Hafouz",value:"Hafouz"},
        {id:"187",tag:"Kairouan",text:"El Aala",value:"El Aala"},
        {id:"188",tag:"Kairouan",text:"Hjaeb Ayoun",value:"Hjaeb Ayoun"},
        {id:"189",tag:"Kairouan",text:"Naser Allah",value:"Naser Allah"},
        {id:"190",tag:"Kairouan",text:"El Chrarda",value:"El Chrarda"},
        {id:"191",tag:"Kairouan",text:"Bouhajla",value:"Bouhajla"},
        {id:"192",tag:"Sidi Bouzid",text:"Sidi Bouzid Ouest",value:"Sidi Bouzid Ouest"},
        {id:"193",tag:"Sidi Bouzid",text:"Sidi Bouzid Oust",value:"Sidi Bouzid Oust"},
        {id:"194",tag:"Sidi Bouzid",text:"Jelma",value:"Jelma"},
        {id:"195",tag:"Sidi Bouzid",text:"Sabalet Awled Asker",value:"Sabalet Awled Asker"},
        {id:"196",tag:"Sidi Bouzid",text:"Bir El Hafi",value:"Bir El Hafi"},
        {id:"197",tag:"Sidi Bouzid",text:"Sidi Ali Ben Oun",value:"Sidi Ali Ben Oun"},
        {id:"198",tag:"Sidi Bouzid",text:"Manzel Bou Zayen",value:"Manzel Bou Zayen"},
        {id:"199",tag:"Sidi Bouzid",text:"El Meknassi",value:"El Meknassi"},
        {id:"200",tag:"Sidi Bouzid",text:"Souq El Jadid",value:"Souq El Jadid"},
        {id:"201",tag:"Sidi Bouzid",text:"Mazouna",value:"Mazouna"},
        {id:"202",tag:"Sidi Bouzid",text:"Regueb",value:"Regueb"},
        {id:"203",tag:"Sidi Bouzid",text:"Awled Hafouz",value:"Awled Hafouz"},
        {id:"204",tag:"Kasserine",text:"Kasserine Nord",value:"Kasserine Nord"},
        {id:"205",tag:"Kasserine",text:"Kasserine Sud",value:"Kasserine Sud"},
        {id:"207",tag:"Kasserine",text:"Hassi El Farid",value:"Hassi El Farid"},
        {id:"208",tag:"Kasserine",text:"Sbietla",value:"Sbietla"},
        {id:"209",tag:"Kasserine",text:"Sbiba",value:"Sbiba"},
        {id:"210",tag:"Kasserine",text:"Jdelyan",value:"Jdelyan"},
        {id:"211",tag:"Kasserine",text:"El Ayoun",value:"El Ayoun"},
        {id:"212",tag:"Kasserine",text:"Telah",value:"Telah"},
        {id:"213",tag:"Kasserine",text:"Hydrah",value:"Hydrah"},
        {id:"214",tag:"Kasserine",text:"Fousana",value:"Fousana"},
        {id:"215",tag:"Kasserine",text:"Feryana",value:"Feryana"},
        {id:"216",tag:"Kasserine",text:"Majel Bel Abbes",value:"Majel Bel Abbes"},
        {id:"217",tag:"Gabes",text:"Gabes Medina",value:"Gabes Medina"},
        {id:"218",tag:"Gabes",text:"Gabes Est",value:"Gabes Est"},
        {id:"219",tag:"Gabes",text:"Gabes Sud",value:"Gabes Sud"},
        {id:"220",tag:"Gabes",text:"Ghannouch",value:"Ghannouch"},
        {id:"221",tag:"Gabes",text:"Metwouya",value:"Metwouya"},
        {id:"223",tag:"Gabes",text:"El Hammah",value:"El Hammah"},
        {id:"224",tag:"Gabes",text:"Matmata ",value:"Matmata "},
        {id:"225",tag:"Gabes",text:"Matmata Jadida ",value:"Matmata Jadida "},
        {id:"226",tag:"Gabes",text:"Mareth",value:"Mareth"},
        {id:"227",tag:"Medenine",text:"Médenine Nord",value:"Médenine Nord"},
        {id:"228",tag:"Medenine",text:"Médenine Sud",value:"Médenine Sud"},
        {id:"229",tag:"Medenine",text:"Bni Khaddach",value:"Bni Khaddach"},
        {id:"230",tag:"Medenine",text:"Ben Gerden",value:"Ben Gerden"},
        {id:"231",tag:"Medenine",text:"Jerjiss",value:"Jerjiss"},
        {id:"232",tag:"Medenine",text:"Jerba Hoummet Essouk",value:"Jerba Hoummet Essouk"},
        {id:"233",tag:"Medenine",text:"Jerba Midoun",value:"Jerba Midoun"},
        {id:"234",tag:"Medenine",text:"Jerba Ajim",value:"Jerba Ajim"},
        {id:"235",tag:"Medenine",text:"Sidi Makhlouf",value:"Sidi Makhlouf"},
        {id:"236",tag:"Gafsa",text:"Gafsa Nord",value:"Gafsa Nord"},
        {id:"237",tag:"Gafsa",text:"Sidi Iich",value:"Sidi Iich"},
        {id:"238",tag:"Gafsa",text:"El Ksar",value:"El Ksar"},
        {id:"239",tag:"Gafsa",text:"Gafsa Sud",value:"Gafsa Sud"},
        {id:"240",tag:"Gafsa",text:"Om El Arayess",value:"Om El Arayess"},
        {id:"241",tag:"Gafsa",text:"Errdayef",value:"Errdayef"},
        {id:"242",tag:"Gafsa",text:"El Metlawi",value:"El Metlawi"},
        {id:"243",tag:"Gafsa",text:"El Mdhilla",value:"El Mdhilla"},
        {id:"244",tag:"Gafsa",text:"El Qattar",value:"El Qattar"},
        {id:"245",tag:"Gafsa",text:"Belkhir",value:"Belkhir"},
        {id:"247",tag:"Tozeur",text:"Tozeur",value:"Tozeur"},
        {id:"248",tag:"Tozeur",text:"Degache",value:"Degache"},
        {id:"249",tag:"Tozeur",text:"Tameghza",value:"Tameghza"},
        {id:"250",tag:"Tozeur",text:"Nefta",value:"Nefta"},
        {id:"251",tag:"Tozeur",text:"Hazoua",value:"Hazoua"},
        {id:"252",tag:"Tataouine",text:"Tataouine Nord",value:"Tataouine Nord"},
        {id:"253",tag:"Tataouine",text:"Tataouine Sud",value:"Tataouine Sud"},
        {id:"254",tag:"Tataouine",text:"Sammar",value:"Sammar"},
        {id:"255",tag:"Tataouine",text:"Bir El Ahmer",value:"Bir El Ahmer"},
        {id:"256",tag:"Tataouine",text:"Ghomrassen",value:"Ghomrassen"},
        {id:"257",tag:"Tataouine",text:"Dhiba",value:"Dhiba"},
        {id:"258",tag:"Tataouine",text:"Remada",value:"Remada"},
        {id:"259",tag:"Kebili",text:"Kébili Sud",value:"Kébili Sud"},
        {id:"260",tag:"Kebili",text:"Kébili Nord",value:"Kébili Nord"},
        {id:"261",tag:"Kebili",text:"Souk Lahad",value:"Souk Lahad"},
        {id:"262",tag:"Kebili",text:"Douz Nord",value:"Douz Nord"},
        {id:"263",tag:"Kebili",text:"Douz Sud",value:"Douz Sud"},
        {id:"264",tag:"Kebili",text:"Faouar",value:"Faouar"}

    ]

}
export default TunMap 